import type { FC } from 'react'

import { Td } from '@skytech/ui/Table/Td'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

import { FormattedNumberWithCurrency } from '@/components/FormattedNumberWithCurrency'
import { Translation } from '@/components/i18n/Translation'
import { LocalDate } from '@/components/LocalDate'
import { TrLink } from '@/components/TrLink'
import Highlight from '@/components/util/Highlight'
import { getTextFilter } from '@/ducks/deviceOrdersReducer'
import { useFormattedNumberWithCurrency } from '@/hooks/use-formatted-number-with-currency'
import { appRoutes } from '@/util/misc'

import ProductVisualizer from '../ProductVisualizer'

const DeviceOrderListItem: FC<any> = ({
  id,
  name,
  code,
  products,
  total_amount,
  remainder_amount,
  statusText,
  down_payments,
  order_date,
  estimated_delivery,
  delivery_date,
  customer_name,
  currency,
}) => {
  const textFilter = useSelector(getTextFilter)
  const { formatNumber } = useFormattedNumberWithCurrency()

  return (
    <TrLink path={appRoutes.deviceOrder.replace(':order_id', id)}>
      <Td>
        <Link to={appRoutes.deviceOrder.replace(':order_id', id)}>
          <Highlight pattern={textFilter} text={String(id)} />
        </Link>
      </Td>

      <Td>
        <div className="customer_name">
          <Highlight pattern={textFilter} text={customer_name} />
        </div>

        <div className="name">
          <Highlight pattern={textFilter} text={name} />
        </div>

        <div className="code">
          <Highlight pattern={textFilter} text={code} />
        </div>
      </Td>

      <Td>
        <Highlight pattern={textFilter} text={statusText} />
      </Td>

      <Td>
        {remainder_amount === 0 ? (
          ''
        ) : (
          <>
            <div className="dp_mth">
              <Translation id="n months" n={down_payments} />
            </div>
            <div className="payment-size">
              <Translation
                id="n/m"
                n={formatNumber({ amount: remainder_amount / down_payments, currency })}
              />
            </div>
          </>
        )}
      </Td>

      <Td className="text-right">
        <div>
          <FormattedNumberWithCurrency amount={total_amount} currency={currency} />
        </div>
        <div className="remainder">{formatNumber({ amount: remainder_amount, currency })}</div>
      </Td>

      <Td className="text-right">
        <LocalDate date={order_date} />
      </Td>
      <Td className="text-right">
        <LocalDate date={delivery_date || estimated_delivery} />
      </Td>

      <Td>
        <ProductVisualizer products={products} />
      </Td>
    </TrLink>
  )
}

export default DeviceOrderListItem
